import { general } from './general'
import { views } from './views'
import { components } from './components'

export const en = {
  general,
  views,
  components,
}
